<template>
  <div class="titan_account_detail_section_header">timeLine</div>
  <div class="titan_account_detail_section_content">asdfasfasfdsa</div>

</template>

<script>
  export default {
    name: 'timeLine'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/demo/components/sections/timeLine.vue